import { persistReducer } from 'redux-persist'
import storage from 'redux-persist/lib/storage'

import { FETCH_STATUSES } from 'resources'

import actions from './actions'

const initialState = {
  fetchAllStatus: FETCH_STATUSES.NOOP,
  fetchSurveyStatus: FETCH_STATUSES.NOOP,
  survey: {},
  currentQuestionIndex: 1,
  answers: {},
  list: [],
}

const reducer = (state = initialState, { type, payload } = {}) => {
  switch (type) {
    case actions.fetchSurvey.INIT_TYPE: {
      return {
        ...state,
        fetchSurveyStatus: FETCH_STATUSES.FETCHING,
      }
    }
    case actions.fetchSurvey.SUCCESS_TYPE: {
      return {
        ...state,
        fetchSurveyStatus: FETCH_STATUSES.SUCCESS,
        survey: payload,
        currentQuestionIndex: 1,
        answers: [],
      }
    }
    case actions.fetchSurvey.FAILURE_TYPE: {
      return {
        ...state,
        fetchSurveyStatus: FETCH_STATUSES.FAILURE,
      }
    }
    case actions.answerQuestion.SUCCESS_TYPE: {
      return {
        ...state,
        answers: {
          ...state.answers,
          [payload.questionId]: payload.value,
        },
      }
    }
    case actions.moveToNextQuestion.SUCCESS_TYPE: {
      const { currentQuestionIndex, survey } = state
      const questionsCount = survey?.questions?.length || 0
      return {
        ...state,
        currentQuestionIndex: currentQuestionIndex < questionsCount ? currentQuestionIndex + 1 : currentQuestionIndex,
      }
    }
    case actions.setCurrentQuestionIndex.SUCCESS_TYPE: {
      return {
        ...state,
        currentQuestionIndex: payload.questionIndex,
      }
    }
    case actions.clearSurvey.SUCCESS_TYPE: {
      return {
        ...state,
        currentQuestionIndex: 1,
        answers: [],
        survey: {},
      }
    }
    case actions.fetchAll.INIT_TYPE: {
      return {
        ...state,
        fetchAllStatus: FETCH_STATUSES.FETCHING,
      }
    }
    case actions.fetchAll.SUCCESS_TYPE: {
      const { results } = payload
      return {
        ...state,
        fetchAllStatus: FETCH_STATUSES.SUCCESS,
        list: results.map((survey) => ({
          ...survey,
          provider: 'killi',
        })),
      }
    }
    case actions.fetchAll.FAILURE_TYPE: {
      return {
        ...state,
        fetchAllStatus: FETCH_STATUSES.FAILURE,
      }
    }
    case actions.submitSurvey.SUCCESS_TYPE: {
      return {
        ...state,
        status: FETCH_STATUSES.SUCCESS,
      }
    }
    case actions.submitSurvey.FAILURE_TYPE: {
      return {
        ...state,
        status: FETCH_STATUSES.FAILURE,
      }
    }
    case 'RESET': {
      return initialState
    }

    default:
      return state
  }
}

const persistConfig = {
  key: 'root',
  storage,
}

export default persistReducer(persistConfig, reducer)
